import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "environments/environment";
import { lastValueFrom } from 'rxjs';
import { GS1NotificationLevel, GS1NotificationService } from '@gs1france/gs1-components-library';
import { TranslateService } from '@ngx-translate/core';
import { CodeOrder } from '../models/code-order.model';
let __URL_API__  = `${environment.URL_API}`;

@Injectable({providedIn: 'root'})
export class CustomerServiceService {

    constructor(private _http: HttpClient, private notificationService: GS1NotificationService, private translate: TranslateService) { }
    
    async unsubscribe(data: any) {
        try {
            const response = await lastValueFrom(this._http.post(`${__URL_API__}api/clientservice/unsubscribe `, data));
            this.sendNotif(this.translate.instant('Unsubscribe.Notification.success'), 'success', 15000);
            return response;
        } catch (err) {
            return await this.handleError(err, this.translate.instant('Unsubscribe.Notification.error'));
        }
    }

    async orderCode(data: FormData, isCB?: boolean) {
        try {
            const response = await lastValueFrom(this._http.post(`${__URL_API__}api/clientservice/requestCode `, data));
            if (!(isCB && isCB === true)) {
                switch (data.get('typeCode')) {
                    case ('UPC') :
                        this.sendNotif(this.translate.instant('Codes.Ordering.success-UPC'), 'success');
                        break;
                    case ('PVAR') :
                        this.sendNotif(this.translate.instant('Codes.Ordering.success-PVAR'), 'success');
                        break;
                    case ('GTIN8') :
                        this.sendNotif(this.translate.instant('Codes.Ordering.success-GTIN8'), 'success');
                        break;
                    case ('GCP') : 
                        this.sendNotif(this.translate.instant('Codes.Ordering.success-GCP'), 'success');
                        break;
                    default: break;
                }
            }
            return response;
        } catch (err) {
            return await this.handleError(err);
        }
    }
    async validateOrder(id: string,): Promise<boolean> {
        try {
            const response =  await lastValueFrom(this._http.get(`${__URL_API__}api/clientservice/Validated/${id} `));
            return;
        } catch (error) {
            return await this.handleError(error);
        }
    }
    async transferCodes(dataForm: FormData) {
        try {
            const response = await lastValueFrom(this._http.post(`${__URL_API__}api/clientservice/transfer `, dataForm));
            this.sendNotif(this.translate.instant('Transfer.Step4.success'), 'success');
            return response;
        } catch (err) {
            return await this.handleError(err, this.translate.instant('Transfer.Step4.error'));
        }
    }
    async createStandard(dataForm: FormData) {
        try {
            const response = await lastValueFrom(this._http.post(`${__URL_API__}api/clientservice/requestStandard `, dataForm));
            this.sendNotif(this.translate.instant('Standard.success'), 'success');
            return response;
        } catch (err) {
            return await this.handleError(err, this.translate.instant('Standard.error'));
        }
    }
    async getLastOrder() {
        try {
            const response = await lastValueFrom(this._http.get<{order: CodeOrder}>(`${__URL_API__}api/clientservice/lastorder `));
            return response;
        } catch (err) {
            await this.handleError(err, this.translate.instant('Erreur'));
            throw err;
        }
    }

    private sendNotif(message: string, level: GS1NotificationLevel, timeInMs: number = 10000) {
        this.notificationService.addNotification(message, level, timeInMs);
    }
    
    private handleError(error: any, message?: string): Promise<any> {
        if (message) {
            this.sendNotif(message, 'error');
        }
        return error.message || error;
    }
}